import type { ValueOf } from '@mathflat/shared/@types/utilityTypes'
import { COMPONENT_TYPE } from '@mathflat/visual-editor'

export type CoverDataType = ValueOf<typeof COVER_DATA_TYPE>

export const COVER_DATA_TYPE = COMPONENT_TYPE

export const COLOR_CHIP_TYPE = {
  WHITE: 'WHITE',
  SKY: 'SKY',
  BLUE_GREEN: 'BLUE_GREEN',
  GREEN: 'GREEN',
  PINK: 'PINK',
  ORANGE: 'ORANGE',
  YELLOW: 'YELLOW',
} as const

export const COLOR_CHIP_KR: Record<ColorChipType, string> = {
  WHITE: '화이트',
  SKY: '스카이',
  BLUE_GREEN: '블루그린',
  GREEN: '그린',
  PINK: '핑크',
  ORANGE: '오렌지',
  YELLOW: '옐로우',
}

export type ColorChipType = ValueOf<typeof COLOR_CHIP_TYPE>
export type ColorChipKrType = ValueOf<typeof COLOR_CHIP_KR>

/**
 * 교재 표지 색상 Hex 값 (Figma 디자인 기준)
 */
export const COLOR_CHIP_HEX: Record<ColorChipType, string> = {
  WHITE: '#FFFFFF',
  SKY: '#37BEF0',
  BLUE_GREEN: '#00ADA9',
  GREEN: '#43B149',
  PINK: '#E098C1',
  ORANGE: '#EE782C',
  YELLOW: '#FCC80E',
}

/**
 * 교재 표지 색상 전체 정보
 */
export const DESIGN_TEMPLATE_COLORS = [
  { key: 'WHITE', name: '화이트', hex: '#FFFFFF' },
  { key: 'SKY', name: '스카이', hex: '#37BEF0' },
  { key: 'BLUE_GREEN', name: '블루그린', hex: '#00ADA9' },
  { key: 'GREEN', name: '그린', hex: '#43B149' },
  { key: 'PINK', name: '핑크', hex: '#E098C1' },
  { key: 'ORANGE', name: '오렌지', hex: '#EE782C' },
  { key: 'YELLOW', name: '옐로우', hex: '#FCC80E' },
] as const

export type DesignTemplateColorKey = (typeof DESIGN_TEMPLATE_COLORS)[number]['key']

export const DESIGN_TEMPLATE_CATEGORIES = [
  '그래픽',
  '일러스트',
  '심플한',
  '동물',
  '수학기호',
  '귀여운',
  '감성적인',
  '전문적인',
] as const

export type DesignTemplateCategoryKey = (typeof DESIGN_TEMPLATE_CATEGORIES)[number]
